module.exports = __webpack_public_path__ + "img/nd.1476ba26.jpg";